import { createAsyncAction } from 'typesafe-actions';
import ProfileType from '@rootCommon/types/profile';
import { ChangePassword } from '@rootCommon/types/password';

export const fetchProfile = createAsyncAction(
  'FETCH_PROFILE_REQUEST',
  'FETCH_PROFILE_SUCCESS',
  'FETCH_PROFILE_FAILURE',
)<undefined, ProfileType, Error>();

export const updateProfile = createAsyncAction(
  'UPDATE_PROFILE_REQUEST',
  'UPDATE_PROFILE_SUCCESS',
  'UPDATE_PROFILE_FAILURE',
)<ProfileType, ProfileType, Error>();

export const changeProfilePassword = createAsyncAction(
  'CHANGE_PROFILE_PASSWORD_REQUEST',
  'CHANGE_PROFILE_PASSWORD_SUCCESS',
  'CHANGE_PROFILE_PASSWORD_FAILURE',
)<ChangePassword, void, Error>();
